/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { Fragment } from "react";
import Loader from "./component/common/loader/loader";
import Header from "./component/common/header/header";
import HeaderSM from "./component/common/header/headerSM";
import Sidebar from "./component/common/sidebar/sidebar";
import SidebarSM from "./component/common/sidebar/sidebarsm";
import Rightsidebar from "./component/common/sidebar/rightsidebar";
import Footer from "./component/common/footer/footer";
import { useGetNavitem } from "./appProvider";
import { ToastContainer } from "react-toastify";
import { GetMyRoleService } from "../../../services";
import { useSMRoles } from "../../../pages/Dashboard/machines";

import GlobalStyles from "./styles";

import {
    useViewport,
    ViewportProvider,
} from "@vlinder-web/viewport-provider-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";

const log: any = LoggerModule?.getInstance();

const getMyRoleService = () => {
    const vapp = VApplication.getInstance();
    const role = vapp.getSync("services.GetMyRoleService") as GetMyRoleService;
    return role;
};

const MENU_ITEMS = [
    {
        eventKey: "manufacturer",
        key: "manufacturer",
        title: "Org",
        icon: <i class="icon-home"></i>,
        path: "/manufacturer",
        type: "sub",
        active: false,
        bookmark: false,
        children: [
            { title: "Manufacturer", type: "sub", key: "manufacturer" },
            {
                title: "Organization",
                type: "link",
                key: "organization",
                path: `/manufacturer`,
            },
            {
                title: "Edit Social Media Links",
                type: "link",
                key: "socialMediaHandles",
                path: `/manufacturer/social-handles`,
            },
        ],
    },
    {
        eventKey: "analytics",
        key: "analytics",
        title: "Analytics",
        icon: <i className="icon-bar-chart-alt"></i>,
        path: "/analytics",
        type: "sub",
        active: false,
        children: [{ title: "Analytics", type: "sub", key: "analytics" }],
    },
    {
        eventKey: "products",
        title: "Products",
        key: "products",
        icon: <i className="icon-shopping-cart-full"></i>,
        path: "/products",
        type: "sub",
        active: false,
        children: [
            { title: "Products", type: "sub", key: "products" },
            // {
            //   title: "New Product",
            //   type: "link",
            //   path: `/products/new-product`,
            // },
        ],
    },
    {
        eventKey: "transactions",
        title: "Txn's",
        key: "transactions",
        icon: <i className="icon-server"></i>,
        path: "/transactions-details",
        type: "sub",
        active: false,
        children: [
            { title: "Transactions", type: "sub", key: "transactions" },
            {
                title: "Transactions",
                type: "link",
                path: `/transactions`,
                key: "transactionsTable",
            },
            {
                title: "Brand Protection",
                type: "link",
                path: `/transactions/brandprotection`,
                key: "brandProtectionTable",
            },
            {
                title: "WB Authenticity Scans",
                type: "link",
                path: `/transactions/wb-authenticity-scans`,
                key: "wbAuthenticityScans",
            },
        ],
    },
    {
        eventKey: "clubRegistration",
        title: "Club Registration",
        key: "clubRegistration",
        icon: <i className="icofont icofont-building"></i>,
        path: "/club-registration",
        type: "sub",
        active: false,
        children: [
            {
                title: "Club Registration",
                type: "sub",
                key: "clubRegistration",
            },
        ],
    },
    {
        eventKey: "Users Profile",
        key: "users",
        title: "Users",
        icon: <i className="icofont icofont-funky-man"></i>,
        path: "/users-profile",
        type: "sub",
        active: false,
        children: [
            { title: "Users Profile", type: "sub", key: "users" },
            {
                title: "User Table",
                type: "link",
                path: `/users-table`,
                key: "userTable",
            },
            {
                title: "Invite New User",
                type: "link",
                path: `/new-user`,
                key: "newUser",
            },
        ],
    },
    {
        eventKey: "campaigns",
        key: "campaigns",
        title: "Campaigns",
        icon: <i className="icon-announcement"></i>,
        path: "/campaigns", // /campaigns-info
        type: "sub",
        active: false,
        children: [
            { title: "Campaigns", type: "sub", key: "campaigns" },
            {
                title: "Campaign Table",
                key: "campaignTable",
                type: "link",
                path: `/campaigns`,
            },
            {
                title: "New Campaign",
                key: "newCampaign",
                type: "link",
                path: `/new-campaign`,
            },
        ],
    },
    {
        eventKey: "personas",
        key: "personas",
        title: "Personas",
        icon: <i className="icofont icofont-business-man-alt-2"></i>,
        path: "/personas",
        type: "sub",
        active: false,
        children: [
            { title: "Personas", type: "sub", key: "personas" },
            {
                title: "Persona Templates",
                key: "personasTemplate",
                type: "link",
                path: "/personas/template",
            },
            {
                title: "Persona Table",
                key: "personasTable",
                type: "link",
                path: "/personas/table",
            },
            {
                title: "Add New Person",
                key: "addNewUser",
                type: "link",
                path: "/personas/new-person",
            },
        ],
    },
    {
        eventKey: "Roles",
        key: "roles",
        title: "Roles",
        icon: <i className="icofont icofont-book-mark"></i>,
        path: "/roles",
        type: "sub",
        active: false,
        children: [
            { title: "Roles", type: "sub", key: "roles" },
            {
                title: "Create Role",
                key: "createRoles",
                type: "link",
                path: `/roles/create-role`,
            },
        ],
    },
    {
        eventKey: "provenance",
        key: "provenance",
        title: "Provenance",
        icon: <i className="icofont icofont-map-pins"></i>,
        path: "/provenance",
        type: "sub",
        active: false,
        children: [
            { title: "Touch Points", type: "sub", key: "provenance" },
            // {
            //   title: "Manage Templates",
            //   type: "link",
            //   path: `/provenance/manage-templates`,
            // },
            // {
            //   title: "New Template",
            //   type: "link",
            //   path: `/provenance/new-template`,
            // },
            // {
            //   title: "New Provenance",
            //   type: "link",
            //   path: `/provenance/association`,
            // },
        ],
    },
    {
        eventKey: "feedback",
        key: "feedback",
        title: "Feedback",
        icon: <i className="icofont icofont-ui-rating"></i>,
        path: "/feedback",
        type: "sub",
        active: false,
        children: [{ title: "Feedback", type: "sub", key: "feedback" }],
    },
    {
        eventKey: "batchSerialization",
        key: "batchSerialization",
        title: "Batch Serialization",
        icon: <i className="icofont icofont-cubes"></i>,
        path: "/batch-level-qr", // "/batch-serialization-info",
        type: "sub",
        active: false,
        children: [
            {
                title: "Batch Serialization",
                type: "sub",
                key: "batchSerialization",
            },

            {
                title: "Create",
                key: "batchLevelQR",
                type: "link",
                path: `/batch-level-qr`,
            },
            {
                title: "View / Associate",
                key: "adminViewBatchQR",
                type: "link",
                path: `/admin-level-qr`,
            },
        ],
    },

    {
        eventKey: "itemSerialization",
        key: "itemSerialization",
        title: "Item Serialization",
        icon: <i className="icofont icofont-cube"></i>,
        path: "/assortment-batches", // "/item-serialization-info",
        type: "sub",
        active: false,
        children: [
            {
                title: "Item Serialization",
                type: "sub",
                key: "itemSerialization",
            },
            {
                title: "Create",
                key: "createAssortmentBatch",
                type: "link",
                path: `/new-assortment-batch`,
            },
            {
                title: "Download",
                key: "assortmentBatch",
                type: "link",
                path: `/assortment-batches`,
            },
            {
                title: "Associate",
                key: "createAssortmentRange",
                type: "link",
                path: `/new-assortment-range`,
            },
            {
                title: "View Associations",
                key: "assortmentRange",
                type: "link",
                path: `/assortment-ranges`,
            },
        ],
    },
    {
        eventKey: "collectibleForm",
        title: "Add New",
        key: "collectibles",
        icon: <i className="icofont icofont-plus"></i>,
        path: "/draft-asset-description",
        type: "sub",
        active: false,
        children: [
            { title: "", type: "sub", key: "collectibles" },
            {
                title: "Add New Item",
                key: "newCollection",
                type: "link",
                path: `/new-collection`,
            },
            {
                title: "DIY Work Flow",
                key: "diyWorkFlow",
                type: "link",
                path: `/diy-work-flow`,
            },
            {
                title: "Create Unique QR/NFC items",
                key: "createQRCodes",
                type: "link",
                path: `/create-qr-codes`,
            },
            {
                title: "Download templates",
                key: "downloadTemplates",
                type: "link",
                path: `/templates`,
            },
            {
                title: "Upload templates",
                key: "uploadCollection",
                type: "link",
                path: `/upload-collection`,
            },
        ],
    },
    {
        eventKey: "sap",
        key: "sap",
        title: "Sap",
        icon: <i className="icofont icofont-tablets"></i>,
        path: "/sap-analytics",
        type: "sub",
        active: false,
        children: [
            { title: "Sap", type: "sub", key: "sap" },
            {
                title: "Sap Analytics",
                type: "link",
                key: "sapAnalytics",
                path: "/sap-analytics",
            },
            {
                title: "Dispatch Data",
                type: "link",
                key: "sapAnalytics",
                path: "/master-dispatch",
            },
        ],
    },
    {
        eventKey: "report",
        key: "report",
        title: "Report",
        icon: <i className="icofont icofont-address-book"></i>,
        path: "/report",
        type: "sub",
        active: false,
        children: [{ title: "Report", type: "sub", key: "report" }],
    },
];

const _getChildren = (data) => {
    let res = [];
    res =
        data &&
        Array.isArray(data) &&
        data?.map((ele: any, index: number) => {
            return {
                key: ele,
            };
        });
    return res;
};

const _getMainChildren = (staticChildren: any, beChildren: any) => {
    let res = [];

    beChildren &&
        Array.isArray(beChildren) &&
        beChildren.length > 0 &&
        beChildren.map((item: any, index: number) => {
            staticChildren &&
                Array.isArray(staticChildren) &&
                staticChildren.length > 0 &&
                staticChildren.forEach((ele: any, index: number) => {
                    if (item?.key === ele?.key) {
                        res.push({
                            ...ele,
                        });
                    }
                });
        });

    return res;
};

const App = ({
    //navItemss,
    children,
}) => {
    const { getRolesState, getRolesMachine, getRolesContext } = useSMRoles({});
    const { bp, width } = useViewport();

    let _sideBarItems = [];
    let count = 0;
    const navItems = getRolesContext?.payload?.FENavItems;
    let res = [];
    let mainItems = [];

    navItems &&
        Array.isArray(navItems) &&
        navItems?.map((ele: any, index: number) => {
            let x = ele && Object.entries(ele);
            mainItems.push({
                key: x && Array.isArray(x) && x.length > 0 && x[0][0],
                children: _getChildren(
                    x && Array.isArray(x) && x.length > 0 && x[0][1]
                ),
            });
        });

    MENU_ITEMS &&
        Array.isArray(MENU_ITEMS) &&
        MENU_ITEMS.map((item) => {
            // if (item?.key === "transactions") {
            //     _sideBarItems.push({
            //         ...item,
            //     });
            // } else if (item?.key === "manufacturer") {
            //     _sideBarItems.push({
            //         ...item,
            //     });
            // } else {
            mainItems &&
                Array.isArray(mainItems) &&
                mainItems?.map((ele: any, index: number) => {
                    if (item?.key === ele?.key) {
                        let _children = _getMainChildren(
                            item?.children,
                            ele?.children
                        );
                        _children &&
                            _sideBarItems.push({
                                ...item,
                                children: _children,
                            });
                    }
                });
            // }
        });

    // Array.isArray(MENU_ITEMS) &&
    //     MENU_ITEMS.map((item) => {
    //         log.info(`navItems item:`, item)
    //         navItems &&
    //             Array.isArray(navItems) &&
    //             navItems?.map((ele: any, index: number) => {
    //                 // let x = ele && ele.entries();
    //                 log.info(`navItems: ele`, ele)
    //             });
    //         // if(item?.key === "ApplicationsAPI"){
    //         //     _sideBarItems.push({ ...item });
    //         // }
    //     });

    if (count > 0) {
        _sideBarItems = MENU_ITEMS;
    }

    // let totalItems = navItems && Array.isArray(navItems) && navItems.length;
    // if (totalItems) {
    //     log.blue(`navItems:`, navItems, "\nlength:", totalItems);
    //     for (let i = 0; i < totalItems; i++) {
    //         log.info(`in for loop:`, navItems[index]?.key);
    //         if (navItems[index]?.key === "all") {
    //             _sideBarItems = MENU_ITEMS;
    //             break;
    //         } else {
    //             MENU_ITEMS.map((item) => {
    //                 if (navItems[index]?.key === item?.key)
    //                     _sideBarItems.push({ ...item });
    //             });
    //             continue;
    //         }
    //     }
    // }

    const getSidebar = () => {
        if (bp === "xs" || bp === "sm") {
            return <SidebarSM menuItems={_sideBarItems} />;
        } else {
            return <Sidebar menuItems={_sideBarItems} />;
        }
    };

    const getHeader = () => {
        if (bp === "xs" || bp == "sm") {
            return <HeaderSM menuItems={_sideBarItems} searchbar={false} />;
        } else {
            return <Header menuItems={_sideBarItems} searchbar={false} />;
        }
    };
    return (
        <Fragment>
            <GlobalStyles />
            <Loader />
            <div className="page-wrapper">
                <div className="page-body-wrapper">
                    {getHeader()}
                    {getSidebar()}
                    <Rightsidebar />
                    <div className="page-body">{children}</div>
                    <Footer />
                    {/* <ThemeCustomize/> */}
                </div>
            </div>
            <ToastContainer
                autoClose={2000}
                position="top-center"
                className="toast-container"
                toastClassName="dark-toast"
            />
        </Fragment>
    );
};

export default App;
